import "core-js/modules/es.array.push.js";
export default {
  name: "UserProductsSubMenusLinks",
  props: {
    loggedUserData: {
      type: Object,
      required: true
    },
    searchCriterias: {
      type: Object,
      required: false
    },
    isExternal: {
      type: Boolean,
      required: false,
      default: false
    },
    forceTab: {
      type: String,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      selectedTab: null,
      tabs: {
        wines: "wines",
        spirits: "spirits"
      }
    };
  },
  watch: {
    $route: function $route(oldRoute, newRoute) {
      if (oldRoute.query.tab !== newRoute.query.tab) {
        this.changeTab();
      }
    }
  },
  created: function created() {
    this.selectedTab = this.$route.query.tab || this.tabs.wines;
    if (this.forceTab) {
      this.selectedTab = this.forceTab;
    }
  },
  methods: {
    changeTab: function changeTab() {
      if (this.forceTab) {
        this.selectedTab = this.forceTab;
      }
      if (this.isExternal) {
        this.$router.push({
          name: "userProductList",
          query: {
            tab: this.$route.query.tab
          },
          force: true
        }).catch(function () {});
      }
      if (this.$route.query.tab) {
        this.selectedTab = this.tabs[this.$route.query.tab];
        this.$emit("tabChanged", this.$route.query.tab);
      } else if (this.selectedTab) {
        this.selectedTab = this.tabs[this.selectedTab];
        this.$emit("tabChanged", this.selectedTab);
      }
      if (!this.selectedTab) {
        this.selectedTab = this.tabs.wineries;
      }
    }
  }
};